const profile = {
    name: 'Imię',
    avatar: 'Avatar',
    givenName: 'Imię własne',
    familyName: 'Nazwisko',
    middleName: 'Drugie imię',
    fullname: 'Pełne imię i nazwisko',
    nickname: 'Pseudonim',
    preferredUsername: 'Preferowana nazwa użytkownika',
    profile: 'Profil',
    website: 'Strona internetowa',
    gender: 'Płeć',
    birthdate: 'Data urodzenia',
    zoneinfo: 'Strefa czasowa',
    locale: 'Język/locale',
    address: {
        formatted: 'Adres',
        streetAddress: 'Ulica',
        locality: 'Miasto',
        region: 'Województwo/region',
        postalCode: 'Kod pocztowy',
        country: 'Kraj',
    },
    gender_options: {
        female: 'Kobieta',
        male: 'Mężczyzna',
        prefer_not_to_say: 'Wolę nie mówić',
    },
};
export default Object.freeze(profile);
